export default __webpack_public_path__ + "media/images/favicon-ceef76f724eba77a6fe108543d92fea7.ico";